module.exports = __webpack_public_path__ + "img/tick.47c70f92.svg";